module.exports = __webpack_public_path__ + "img/pauli-y-root-33.c9df35aa.svg";